var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSiteBlindado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "502px",
    height: "113px",
    viewBox: "0 0 502 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-site-blindado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "99.9795418%",
    cy: "100.694344%",
    fx: "99.9795418%",
    fy: "100.694344%",
    r: "113.554583%",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F600",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "77.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "0.214151188%",
    cy: "99.1243354%",
    fx: "0.214151188%",
    fy: "99.1243354%",
    r: "99.7432771%",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009800",
    offset: "90.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009800",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "100.514027%",
    cy: "-0.428391167%",
    fx: "100.514027%",
    fy: "-0.428391167%",
    r: "100.845249%",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009800",
    offset: "90.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009800",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-0.509070295%",
    cy: "-0.428391167%",
    fx: "-0.509070295%",
    fy: "-0.428391167%",
    r: "101.258503%",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F600",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "77.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CB00",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-site-blindado"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.9,84.3 C501.9,90.5 494.9,96.7 487.8,96.7 L14,96.7 C7,96.7 0,90.5 0,84.3 L0,28.3 C0,22.1 7,15.9 13.9,15.9 L487.9,15.9 C494.9,15.9 501.8,22.1 501.8,28.3 L501.8,84.3 L501.9,84.3 Z",
    id: "Shape",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "escudo-siteblindado"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7,86.8 C81.5,73 93,49.5 86.8,16.4 L86.8,16.3 L86.7,16.3 C86.5,16.2 71.5,7.5 45.4,3.4 C19.4,7.4 4.3,16.2 4.2,16.3 L4.1,16.3 L4.1,16.4 C-2,49.5 9.6,72.9 20.4,86.8 C32.1,101.8 45.4,109.1 45.5,109.1 L45.6,109.1 L45.7,109.1 C45.7,109 59.1,101.8 70.7,86.8 L70.7,86.8 Z",
    id: "Shape",
    fill: "#00CB00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,13.9 C-0.4,26.7 -0.3,38.2 1.3,48.4 C1.5,49.5 1.4,49 1.4,49 L45.6,49 L45.6,0.1 C17.7,4.5 2,13.9 2,13.9 L2,13.9 Z",
    id: "Shape",
    fill: "url(#radialGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,13.9 C91.5,27 91.4,38.6 89.6,49 L45.4,49 L45.4,0.1 C73.4,4.5 89.1,13.9 89.1,13.9 L89.1,13.9 Z",
    id: "Shape",
    fill: "url(#radialGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6,112.4 L45.6,49 L1.4,49 C8.2,91.8 45.6,112.4 45.6,112.4 L45.6,112.4 Z",
    id: "Shape",
    fill: "url(#radialGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,61.3 C86.7,61.3 89.2,52.3 89.7,49 L45.6,49 L45.6,112.4 C45.6,112.4 75.3,96.2 86.7,61.3 L86.7,61.3 Z",
    id: "Shape",
    fill: "url(#radialGradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.000000, 33.000000)",
    id: "Shape",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.6,36.5 C3.5,37.5 6.7,38.2 9.4,38.2 C13.8,38.2 15.9,36.1 15.9,33.3 C15.9,30.1 13.8,28.6 9.8,26.2 C3.3,22.6 0.8,17.9 0.8,14 C0.8,7 5.9,1.1 15.8,1.1 C18.9,1.1 21.9,1.9 23.3,2.7 L21.8,10 C20.5,9.2 18.4,8.5 15.7,8.5 C11.8,8.5 9.8,10.7 9.8,13.1 C9.8,15.7 11.2,17.1 16.4,19.9 C22.7,23.4 25,27.8 25,32.4 C25,40.4 18.6,45.7 9.3,45.7 C5.5,45.7 1.8,44.8 0.2,43.9 L1.6,36.5 L1.6,36.5 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.7 1.4 39.7 45.2 30.5 45.2 30.5 1.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.1 9.2 44.7 9.2 44.7 1.3 70.8 1.3 70.8 9.2 62.3 9.2 62.3 45.1 53.1 45.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.7 25.9 84.8 25.9 84.8 37.7 97.1 37.7 97.1 45.1 75.6 45.1 75.6 1.4 96.3 1.4 96.3 8.8 84.9 8.8 84.9 18.9 95.8 18.9 95.8 25.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6,2 C117.4,1.4 121.1,1.2 125.1,1.2 C129.5,1.2 133.8,1.7 137.2,4.3 C139.7,6.2 140.8,9.2 140.8,12.2 C140.8,16.1 138.6,19.9 133.9,21.8 L133.9,22 C139.4,23.4 142.4,27.7 142.4,32.5 C142.4,36.1 141.1,38.9 138.9,41.1 C136.1,44 131.3,45.5 123.3,45.5 C119.8,45.5 116.8,45.3 114.7,45 L114.7,2 L114.6,2 Z M123.9,19.4 L125.9,19.4 C129.2,19.4 131.8,16.8 131.8,13.2 C131.8,10 130.2,7.5 126.4,7.5 C125.4,7.5 124.6,7.6 124,7.8 L124,19.4 L123.9,19.4 Z M123.9,38.8 C124.5,38.9 125.1,38.9 125.9,38.9 C129.6,38.9 132.7,36.8 132.7,32.3 C132.7,27.9 129.5,25.7 125.8,25.6 L123.8,25.6 L123.8,38.8 L123.9,38.8 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.7 1.4 157.9 1.4 157.9 38 170.1 38 170.1 45.2 148.7 45.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.7 1.4 184.7 45.2 175.5 45.2 175.5 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,45.2 L193,1.4 L201.5,1.4 L208.8,18.6 C210.2,22 212.5,27.6 213.9,31.4 L214,31.4 C213.7,26.8 213.1,19.2 213.1,11.1 L213.1,1.4 L221.2,1.4 L221.2,45.2 L212.7,45.2 L205.4,28.6 C203.8,24.9 201.7,19.4 200.6,15.4 L200.5,15.4 C200.7,19.8 201.1,26.6 201.1,35.4 L201.1,45.3 L193,45.3 L193,45.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.3,2 C231.6,1.5 235,1.2 238.7,1.2 C244.7,1.2 248.9,2.5 251.9,5.1 C256,8.5 258.1,14.3 258.1,22.8 C258.1,31.6 255.6,37.9 251.5,41.3 C248.3,44.2 243.6,45.5 237,45.5 C234.1,45.5 231.2,45.2 229.4,45 L229.4,2 L229.3,2 Z M238.6,38.4 C239,38.5 239.7,38.5 240.2,38.5 C244.6,38.5 248.5,34.5 248.5,22.4 C248.5,13.4 246,8 240.4,8 C239.8,8 239.1,8 238.6,8.2 L238.6,38.4 L238.6,38.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,35.2 L268.3,45.2 L259.3,45.2 L269.6,1.4 L280.7,1.4 L289.9,45.2 L280.9,45.2 L278.9,35.2 L270.4,35.2 L270.4,35.2 Z M278.1,28.5 L276.5,19.3 C276,16.6 275.4,12.3 274.9,9.4 L274.7,9.4 C274.2,12.3 273.5,16.9 273,19.4 L271.2,28.5 L278.1,28.5 L278.1,28.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.1,2 C297.4,1.5 300.8,1.2 304.5,1.2 C310.5,1.2 314.7,2.5 317.7,5.1 C321.8,8.5 323.9,14.3 323.9,22.8 C323.9,31.6 321.4,37.9 317.3,41.3 C314.1,44.2 309.4,45.5 302.8,45.5 C299.9,45.5 297,45.2 295.2,45 L295.2,2 L295.1,2 Z M304.4,38.4 C304.8,38.5 305.5,38.5 306,38.5 C310.4,38.5 314.3,34.5 314.3,22.4 C314.3,13.4 311.8,8 306.2,8 C305.6,8 304.9,8 304.4,8.2 L304.4,38.4 L304.4,38.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.8,22.5 C357.8,39 351.5,45.7 342.4,45.7 C331.6,45.7 327.4,35.2 327.4,23.1 C327.4,11.1 332.5,0.8 343.1,0.8 C354.6,0.9 357.8,12.5 357.8,22.5 L357.8,22.5 Z M337,23.3 C337,33.2 339,38.3 342.8,38.3 C346.7,38.3 348.2,31.8 348.2,22.9 C348.2,15.2 346.9,8.3 342.8,8.3 C339.1,8.3 337,13.9 337,23.3 L337,23.3 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiteBlindado);
export default __webpack_public_path__ + "static/media/logo-site-blindado.2c1c662583f486ff51dfe4987092d113.svg";
export { ForwardRef as ReactComponent };